import { ReactNode } from 'react'
import { MediaOwnerListItemBase } from './media-owner-list-item-base'
import { HallAvatar } from '$common/avatar'
import { useHall } from '$logic/hall/react-hook'
import { UserListItemSkeleton } from '$common/user-list-item'
import { AvatarSize } from '$common/avatar/avatar-base/types'

interface Props {
  channelId: string
  secondaryText: string
  secondaryActionComponent: ReactNode
}

export function MediaChannelListItem({
  channelId,
  secondaryText,
  secondaryActionComponent,
}: Props) {
  const { entity: channel, loading: channelLoading } = useHall(channelId)

  if (channelLoading || !channel) return <UserListItemSkeleton />

  return (
    <MediaOwnerListItemBase
      isTransparent
      primaryText={channel.name}
      secondaryText={secondaryText}
      secondaryActionComponent={secondaryActionComponent}
      avatarComponent={<HallAvatar roomId={channelId} size={AvatarSize.MD} />}
    />
  )
}
